import {
  LayoutDashboard,
  Calendar,
  Folder,
  Radio,
  ArrowRightLeft,
  Plus,
  FileText,
  Building2,
  User,
  BookOpen,
  BarChart3,
  Scale,
  TrendingUp,
  Receipt,
  CircleHelp,
  Download,
  Lock,
  SlidersHorizontal,
  Bell,
  Landmark,
  Wallet,
  ImagePlus,
  Users,
  Truck,
  Wrench,
  Package,
} from 'lucide-react';
import { CommandPaletteItem } from 'types/commandPalette';
import { ROUTES } from 'utils/constants';

export const commandPaletteItems: CommandPaletteItem[] = [
  {
    id: 'dashboard',
    titleKey: 'commandPalette.items.dashboard',
    keywords: ['home', 'overview', 'main', 'start'],
    icon: LayoutDashboard,
    path: ROUTES.DASHBOARD,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'tax-calendar',
    titleKey: 'commandPalette.items.taxCalendar',
    keywords: [
      'tax',
      'bir',
      'calendar',
      'deadline',
      'cor',
      '2303',
      'compliance',
      '1701q',
    ],
    icon: Calendar,
    path: ROUTES.TAX_COMPLIANCE,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'eis-transmissions-log',
    titleKey: 'commandPalette.items.eisTransmissionsLog',
    keywords: [
      'eis',
      'bir',
      'transmission',
      'invoice',
      'pos',
      '3-day',
      'jws',
      'audit',
      'compliance',
    ],
    icon: Radio,
    path: ROUTES.POS.REPORTS_EIS_TRANSMISSIONS_LOG,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'business-calendar',
    titleKey: 'commandPalette.items.businessCalendar',
    keywords: [
      'business',
      'permit',
      'mayor',
      'barangay',
      'fsic',
      'bmbe',
      'philhealth',
      'sss',
      'pagibig',
      'payroll',
      'renewal',
      'compliance',
    ],
    icon: Calendar,
    path: ROUTES.BUSINESS_CALENDAR,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'events-management',
    titleKey: 'commandPalette.items.events',
    keywords: [
      'events',
      'registration',
      'attendance',
      'scanner',
      'qr',
      'ticket',
      'campaign',
    ],
    icon: Calendar,
    path: ROUTES.EVENTS.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'reserve',
    titleKey: 'commandPalette.items.reserve',
    keywords: [
      'reserve',
      'reservation',
      'booking',
      'venue',
      'place',
      'slot',
      'calendar',
    ],
    icon: Calendar,
    path: ROUTES.RESERVE.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'file-manager',
    titleKey: 'commandPalette.items.fileManager',
    keywords: [
      'files',
      'folder',
      'drive',
      'storage',
      'upload',
      'documents',
      'file manager',
    ],
    icon: Folder,
    path: ROUTES.FILE_MANAGER,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'categories',
    titleKey: 'commandPalette.items.categories.title',
    keywords: [
      'accounts',
      'chart of accounts',
      'assets',
      'liabilities',
      'equity',
      'revenue',
      'expenses',
      'master data',
      'cate',
      'folder',
    ],
    icon: Folder,
    path: ROUTES.CATEGORIES.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'transactions',
    titleKey: 'commandPalette.items.transactions.title',
    keywords: [
      'journal entries',
      'debit',
      'credit',
      'record',
      'bookkeeping',
      'entries',
    ],
    icon: ArrowRightLeft,
    path: ROUTES.TRANSACTIONS.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'help',
    titleKey: 'commandPalette.items.help',
    keywords: [
      'help center',
      'support',
      'docs',
      'documentation',
      'how to',
      'guide',
      'tutorial',
      'faq',
      'need help',
    ],
    icon: CircleHelp,
    path: ROUTES.HELP,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'downloadables',
    titleKey: 'commandPalette.items.downloadables.title',
    keywords: [
      'download',
      'downloadable',
      'sample',
      'template',
      'format',
      'general journal',
      'pdf',
      'example',
    ],
    icon: Download,
    path: ROUTES.DOWNLOADABLES,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'add-transaction',
    titleKey: 'commandPalette.items.addTransaction.title',
    keywords: [
      'new transaction',
      'create transaction',
      'journal entry',
      'record',
    ],
    icon: Plus,
    path: ROUTES.TRANSACTIONS.ADD,
    sectionKey: 'commandPalette.sections.actions',
  },
  {
    id: 'journals',
    titleKey: 'commandPalette.items.journalsHub.title',
    keywords: [
      'journals',
      'journal hub',
      'cash receipts',
      'general journal',
      'ledger books',
      'accounting books',
      'non vat',
      'non-vat',
      'non vat books',
      'non-vat cash books',
      'cash books',
      'accrual books',
    ],
    icon: BookOpen,
    path: ROUTES.JOURNALS.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'instoreqr-menu-import',
    titleKey: 'commandPalette.items.instoreqrMenuImport.title',
    keywords: [
      'instoreqr',
      'in-store qr',
      'import products',
      'import menu',
      'menu photo',
      'ai products',
    ],
    icon: ImagePlus,
    path: ROUTES.INSTOREQR.MENU_IMPORT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'customers',
    titleKey: 'commandPalette.items.customers.title',
    keywords: [
      'customers',
      'customer list',
      'buyers',
      'clients',
      'sales customers',
      'customer directory',
    ],
    icon: Users,
    path: ROUTES.JOURNALS.CUSTOMERS,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'suppliers',
    titleKey: 'commandPalette.items.suppliers.title',
    keywords: [
      'suppliers',
      'supplier list',
      'vendors',
      'expense suppliers',
      'supplier directory',
      'payees',
    ],
    icon: Truck,
    path: ROUTES.JOURNALS.SUPPLIERS,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'biller-management',
    titleKey: 'commandPalette.items.billerManagement.title',
    keywords: [
      'biller',
      'bills',
      'accounts payable',
      'ap',
      'vendor bills',
      'bills ledger',
      'payables',
    ],
    icon: Wallet,
    path: ROUTES.BILLS_LEDGER.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'ar-invoices',
    titleKey: 'commandPalette.items.arInvoices.title',
    keywords: [
      'invoices',
      'ar invoices',
      'accounts receivable',
      'sales invoice',
      'customer invoice',
      'billing',
    ],
    icon: Receipt,
    path: ROUTES.AR_INVOICES.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'equipment-management',
    titleKey: 'commandPalette.items.equipmentManagement.title',
    keywords: [
      'equipment',
      'fixed assets',
      'depreciation',
      'ppe',
      'asset register',
    ],
    icon: Wrench,
    path: ROUTES.EQUIPMENT.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'capital-management',
    titleKey: 'commandPalette.items.capitalManagement.title',
    keywords: [
      'capital',
      'capitals',
      'owner investment',
      'owner withdrawal',
      'equity',
      'invested capital',
    ],
    icon: Landmark,
    path: ROUTES.CAPITALS.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'cash-receipts-journal',
    titleKey: 'commandPalette.items.cashReceiptsJournal.title',
    keywords: [
      'cash receipts',
      'receipts journal',
      'crj',
      'cash receipts journal',
      'receipt book',
      'encode',
      'libro',
      'listahan',
      'or number',
      'or#',
      'official receipt',
      'manual receipt',
      'cash sales',
      'sales receipt',
      'paper journal',
    ],
    icon: BookOpen,
    path: ROUTES.CASH_RECEIPTS_JOURNAL.ROOT,
    sectionKey: 'commandPalette.sections.pages',
  },
  {
    id: 'new-cash-receipts-journal',
    titleKey: 'commandPalette.items.newCashReceipt',
    keywords: [
      'new receipt',
      'record receipt',
      'add receipt',
      'encode receipt',
      'log receipt',
      'cash receipt entry',
      'or number',
      'official receipt',
      'crj new',
    ],
    icon: Plus,
    path: ROUTES.CASH_RECEIPTS_JOURNAL.NEW,
    sectionKey: 'commandPalette.sections.actions',
  },
  {
    id: 'cash-receipts-journal-hints',
    titleKey: 'commandPalette.items.cashReceiptTips',
    keywords: [
      'void receipt',
      'undo void',
      'receipt history',
      'version history',
      'rollback receipt',
      'edit receipt',
      'view receipt',
      'linked transaction',
      'duplicate or',
    ],
    icon: BookOpen,
    path: ROUTES.CASH_RECEIPTS_JOURNAL.ROOT,
    sectionKey: 'commandPalette.sections.actions',
  },
  {
    id: 'trial-balance',
    titleKey: 'commandPalette.items.trialBalance.title',
    keywords: [
      'trial balance',
      'debits and credits',
      'account totals',
      'verify books',
      'ledger totals',
    ],
    icon: Scale,
    path: ROUTES.REPORTS.TRIAL_BALANCE,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'income-statement',
    titleKey: 'commandPalette.items.incomeStatement.title',
    keywords: [
      'income statement',
      'profit and loss',
      'P&L',
      'revenue report',
      'earnings',
      'financial report',
    ],
    icon: BarChart3,
    path: ROUTES.REPORTS.INCOME_STATEMENT,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'balance-sheet',
    titleKey: 'commandPalette.items.balanceSheet.title',
    keywords: [
      'balance sheet',
      'assets and liabilities',
      'financial position',
      'net worth',
      'equity report',
    ],
    icon: TrendingUp,
    path: ROUTES.REPORTS.BALANCE_SHEET,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'cash-flow-statement',
    titleKey: 'commandPalette.items.cashFlowStatement.title',
    keywords: [
      'cash flow',
      'cash flow statement',
      'operating',
      'investing',
      'financing',
      'liquidity',
    ],
    icon: FileText,
    path: ROUTES.REPORTS.CASH_FLOW_STATEMENT,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'statement-of-changes-in-equity',
    titleKey: 'commandPalette.items.statementOfChangesInEquity.title',
    keywords: [
      'equity changes',
      'owner equity',
      'retained earnings movement',
      'capital changes',
    ],
    icon: FileText,
    path: ROUTES.REPORTS.STATEMENT_OF_CHANGES_IN_EQUITY,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'financial-statement-generation',
    titleKey: 'commandPalette.items.financialStatementGeneration.title',
    keywords: [
      'fs package',
      'management responsibility',
      'accompanying notes',
      'annual income tax return',
    ],
    icon: FileText,
    path: ROUTES.REPORTS.FINANCIAL_STATEMENT,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'general-ledger',
    titleKey: 'commandPalette.items.generalLedger.title',
    keywords: [
      'ledger',
      'account history',
      'running balance',
      'reconciliation',
    ],
    icon: BookOpen,
    path: ROUTES.REPORTS.GENERAL_LEDGER,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'items-sold-ledger',
    titleKey: 'commandPalette.items.itemsSoldLedger.title',
    keywords: [
      'items sold',
      'product sales',
      'gross profit',
      'pos ledger',
      'item sales',
      'detailed sales',
    ],
    icon: Package,
    path: ROUTES.POS.REPORTS_ITEMS_SOLD_LEDGER,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'general-journal',
    titleKey: 'commandPalette.items.generalJournal.title',
    keywords: ['journal', 'all entries', 'chronological', 'audit trail'],
    icon: FileText,
    path: ROUTES.REPORTS.GENERAL_JOURNAL,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'cash-receipts-journal-report',
    titleKey: 'commandPalette.items.cashReceiptsJournalReport.title',
    keywords: [
      'cash receipts',
      'income report',
      'receipts journal report',
      'or report',
      'sales report',
    ],
    icon: Receipt,
    path: ROUTES.REPORTS.CASH_RECEIPTS_JOURNAL,
    sectionKey: 'commandPalette.sections.reports',
  },
  {
    id: 'cash-disbursement-journal-report',
    titleKey: 'commandPalette.items.cashDisbursementJournalReport.title',
    keywords: [
      'cash disbursements',
      'expense report',
      'disbursement journal report',
      'cv report',
      'payments report',
    ],
    icon: Wallet,
    path: ROUTES.REPORTS.CASH_DISBURSEMENT_JOURNAL,
    sectionKey: 'commandPalette.sections.reports',
  },

  {
    id: 'transaction-period-locks',
    titleKey: 'commandPalette.items.transactionLocking',
    keywords: [
      'transaction locking',
      'lock period',
      'close books',
      'freeze dates',
      'accounting lock',
      'BIR',
    ],
    icon: Lock,
    path: ROUTES.SETTINGS.TRANSACTION_PERIOD_LOCKS,
    sectionKey: 'commandPalette.sections.account',
  },
  {
    id: 'company-details',
    titleKey: 'commandPalette.items.companyDetails.title',
    keywords: [
      'company profile',
      'organization',
      'tin',
      'registration',
      'business details',
      'company information',
    ],
    icon: Landmark,
    path: ROUTES.SETTINGS.COMPANY_DETAILS,
    sectionKey: 'commandPalette.sections.account',
  },
  {
    id: 'companies',
    titleKey: 'commandPalette.items.companies.title',
    keywords: ['business', 'organization', 'company list', 'switch company'],
    icon: Building2,
    path: ROUTES.SETTINGS.COMPANIES,
    sectionKey: 'commandPalette.sections.account',
  },
  {
    id: 'general-settings',
    titleKey: 'commandPalette.items.generalSettings',
    keywords: [
      'general settings',
      'preferences',
      'ui mode',
      'language',
      'currency display',
    ],
    icon: SlidersHorizontal,
    path: ROUTES.SETTINGS.GENERAL,
    sectionKey: 'commandPalette.sections.account',
  },
  {
    id: 'notification-settings',
    titleKey: 'commandPalette.items.notificationSettings',
    keywords: [
      'notification settings',
      'email notifications',
      'alerts',
      'tax calendar',
      'low stock',
    ],
    icon: Bell,
    path: ROUTES.SETTINGS.NOTIFICATIONS,
    sectionKey: 'commandPalette.sections.account',
  },
  {
    id: 'view-profile',
    titleKey: 'commandPalette.items.viewProfile.title',
    keywords: ['account', 'settings', 'user', 'my profile', 'personal'],
    icon: User,
    path: ROUTES.SETTINGS.PROFILE,
    sectionKey: 'commandPalette.sections.account',
  },
];
